import Kfit from 'integrations/Kfit';

export const refundFaveLoyaltyProgramTransaction = (id, params) =>
  Kfit.post(`/v1/flp_payments/${id}/refund`, params);
